import { render } from "./InterviewPage.vue?vue&type=template&id=4ad54894&scoped=true"
import script from "./InterviewPage.vue?vue&type=script&lang=js"
export * from "./InterviewPage.vue?vue&type=script&lang=js"

import "./InterviewPage.vue?vue&type=style&index=0&id=4ad54894&scoped=true&lang=css"

import exportComponent from "D:\\project2025\\green-lit-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad54894"]])

export default __exports__